import { useCookies } from "react-cookie";
import styled from "@emotion/styled";
import { Text } from "components/general/Text";
import { css } from "@emotion/react";
import React from "react";

const COOKIE_KEY = "acceptcookies";
const ONE_YEAR_MS = 31536000;

export const CookieBanner: React.FC = () => {
  const [cookies, setCookie, removeCookie] = useCookies();

  const allowCookies = () => {
    setCookie(COOKIE_KEY, true, {
      path: "/",
      maxAge: new Date(ONE_YEAR_MS).getTime(), // 1 Year
    });
  };

  const declineCookies = () => {
    setCookie("acceptcookies", false, {
      path: "/",
      maxAge: new Date(ONE_YEAR_MS).getTime(), // 1 Year
    });
    const bebopCookies = ["termsandconditions", "tokenlistbanner"];
    bebopCookies.forEach(element => {
      removeCookie(element, {
        path: "/",
      });
    });
  };

  if (cookies[COOKIE_KEY]) {
    return null;
  }

  return (
    <Container className="bottom-0 end-0">
      <Title>This website uses cookies</Title>
      <Text
        textStyle="Paragraph"
        size="Medium"
        textCss={css`
          margin-bottom: 16px;
          letter-spacing: 0;
          line-height: 1.5;
          font-weight: 300;
        `}
      >
        We use cookies to ensure that we give you the best experience on our website. For more
        information, please read our{" "}
        <a href="/privacy.pdf" target="_blank" className="text-link text-decoration-underline">
          Privacy Policy
        </a>
        .
      </Text>
      <div className="d-flex justify-content-center">
        <SuccessButton
          className="btn-success w-100"
          onClick={allowCookies}
          data-testid="cookie-success-btn"
        >
          Accept
        </SuccessButton>
        <DeclineButton className="w-100" onClick={declineCookies}>
          Decline
        </DeclineButton>
      </div>
    </Container>
  );
};

// Sub-components

const Container = styled.div`
  background-color: #192e2e;
  color: white;
  position: fixed;
  padding: 28px;
  border-radius: 16px;
  max-width: 336px;
  z-index: 999;
  bottom: 0;
  margin-bottom: 24px;
  margin-right: 24px;
`;

const Title = styled.h2`
  font-family: "quincy-cf";
  font-size: 24px;
  line-height: 120%;
  font-weight: 400;
  letter-spacing: 0;
`;

const SuccessButton = styled.button`
  border: 0;
  padding: 17px 23px 19px;
  height: 54px;
  background: #01b04c;
  border-radius: 2432px;
  margin-right: 8px;
  font-weight: 500;
  font-size: 16px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Work Sans";
`;

const DeclineButton = styled.button`
  padding: 17px 23px 19px;
  height: 54px;
  background: #192e2e;
  color: white;
  border: 1px solid #01b04b;
  border-radius: 2432px;
  margin-right: 8px;
  font-weight: 500;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Work Sans";

  &:hover {
    background-color: #18c761;
    border-color: #18c761;
    color: #fff;
  }
`;
